import { listVotes } from "../../action/votes"

export const votesLoader = async () => {

    await listVotes()

}
